import * as tslib_1 from "tslib";
import { EventEmitter } from "@angular/core";
import { BaseComponent } from "../../base/base.component";
import { AppComponent } from "../../app.component";
import { Router } from "@angular/router";
import { PhotosphereManager } from "../../../business/managers/photosphere.manager";
import { PromotionModel } from "../../../datastore/entities/promotion.model";
import { Location } from "@angular/common";
import { AlertUtils } from "../../../crossconcern/utilities/utils/alert.utils";
import { NurseryModel } from "app/datastore/entities/nursery.model";
var PromotionEditorComponent = /** @class */ (function (_super) {
    tslib_1.__extends(PromotionEditorComponent, _super);
    function PromotionEditorComponent(appComponent, router, photosphereManager, location, alertUtils) {
        var _this = _super.call(this, appComponent, router, alertUtils, location) || this;
        _this.appComponent = appComponent;
        _this.router = router;
        _this.photosphereManager = photosphereManager;
        _this.location = location;
        _this.alertUtils = alertUtils;
        _this.promoDelete = new EventEmitter();
        _this.promoSave = new EventEmitter();
        return _this;
    }
    PromotionEditorComponent.prototype.ngOnInit = function () {
        this.init();
    };
    PromotionEditorComponent.prototype.ngOnChanges = function () {
        // logData("CHANGES");
        this.init();
    };
    PromotionEditorComponent.prototype.init = function () {
        if (this.editedPromo && this.editedPromo.products) {
            var prods = [];
            for (var _i = 0, _a = this.editedPromo.products; _i < _a.length; _i++) {
                var prod = _a[_i];
                // logData("PROD");
                // logData(prod);
                prods.push(prod.product);
            }
            this.selectedItems = prods;
        }
        else {
            this.selectedItems = [];
        }
        this.dropdownSettings = {
            singleSelection: false,
            idField: "uuid",
            textField: "name",
            enableCheckAll: false,
            allowSearchFilter: true
        };
        if (this.editedPromo) {
            this.promoName = this.editedPromo.title;
            this.promoDesc = this.editedPromo.description;
        }
    };
    PromotionEditorComponent.prototype.onPromoDelete = function () {
        this.promoDelete.emit();
    };
    PromotionEditorComponent.prototype.onPromoSave = function () {
        var currentNursery;
        if (this.nurseryUuid) {
            currentNursery = new NurseryModel("");
            currentNursery.uuid = this.nurseryUuid;
        }
        this.promoSave.emit({
            title: this.promoName,
            description: this.promoDesc,
            products: this.selectedItems,
            nurseries: [
                currentNursery
            ]
        });
    };
    PromotionEditorComponent.prototype.onItemSelect = function (_) {
        // empty
    };
    PromotionEditorComponent.prototype.onSelectAll = function (_) {
        // empty
    };
    return PromotionEditorComponent;
}(BaseComponent));
export { PromotionEditorComponent };
